<template>
<div class="search-place">
  <megaMenu ref="placeDropdown" :tabindex="false">
    <template v-if="isDesktop || isInline || forceDesktop">
      <!-- 輸入框 -->
      <div v-if="textOnly">{{ inputValue }}</div>
      <div v-else class="search-place__input" id="search-place__input">
        <i class="icon owl-search"></i>
        <input
          ref="placeInput"
          type="text"
          :placeholder="placeholder ? placeholder : $t('searchForLocation')"
          v-model="inputValue"
          @focus="focusHandler"
          @compositionstart="compositionHandler"
          @compositionupdate="compositionHandler"
          @compositionend="compositionHandler"
          @keydown.down.prevent="onArrowKeysPressed"
          @keydown.up.prevent="onArrowKeysPressed"
          @keydown.enter="onArrowKeysPressed"
          @click="searchInputClick"
        >
      </div>
    </template>
    <template v-else>
      <div class="search-place__mobile-input">
        <span>{{ inputValue }}</span>
      </div>
    </template>
    <template v-slot:dropdown>
      <!-- 下拉選單 -->
      <div class="search-place__dropdown is-open shadow">
        <!-- 讀取中 -->
        <template v-if="isLoading">
          <resultCard v-for="i in 6" :key="i" loading/>
        </template>
        <!-- 得到結果 -->
        <template v-else>
          <template v-if="list && list.length > 0">
            <div class="chatbot-block">
              <div class="flex items-center justify-between rounded-sm p-8 text-xs text-blue" style="background: #F8FAFC;">
                <div class="flex items-center">
                  <div class="text-white rounded-sm p-8 font-bold" style="background: #3AB3E2">
                    NEW
                  </div>
                  <p class="ml-8 text-sm">{{ $t('chatbot.ask') }}<router-link class="text-blue nunderline" :to="{ name: 'Socket' }" @click.native="gaEvent">{{ $t('chatbot.aibot') }}</router-link>?</p>
                </div>
                <!-- <i class="text-base owl owl-status-error" @click="closeAIbot"></i> -->
              </div>
              <!-- <div v-if="!inputValue && !isLoading" class="text-sm font-medium mt-8">熱門搜尋區域</div> -->
            </div>
            <resultCard v-for="(item, index) in list"
              class="whitespace-normal"
              @mouseover.native="selectedIndex = index"
              @mouseleave.native="selectedIndex = false"
              @click="onResultCardClick(item)"
              :title="item.name"
              :type="item.type"
              :typeText="item.typeText"
              :location="item.administrativeAreaName"
              :imageUrl="item.imageUrl"
              :activated="selectedIndex === index"
              selectable
              :key="index"
            />
            <!-- <div @click="goToMoreContent" class="cursor-pointer block no-underline bg-white p-16 text-center text-blue text-sm rounded-b hover:bg-grey-lightest">
              {{ $t('goToMoreContent') }}
            </div> -->
          </template>
          <template v-else>
            <div class="bg-white border-1 border-grey-lightest p-16">
              <span class="text-sm"><i class="owl-status-triangle-warning text-orange mr-8"></i>{{ $t('tryAnotherKeyword') }}</span>
            </div>
          </template>
        </template>
      </div>
    </template>
  </megaMenu>
</div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters, mapMutations } from 'vuex'

import resultCard from './components/resultCard'
import SimpleVueValidation from 'simple-vue-validator'
import animateScrollTo from 'animated-scroll-to'

const Validator = SimpleVueValidation.Validator

export default {
  name: 'searchPlaceInput',
  components: {
    resultCard
  },
  props: {
    forceDesktop: {
      type: Boolean
    },
    isInline: {
      type: Boolean
    },
    placeholder: {
      type: String,
      default: ''
    },
    textOnly: {
      type: Boolean,
      default: false
    }
  },
  validators: {
    'selected': function (val) {
      if (typeof val === 'undefined') {
        val = null
      }
      return Validator.value(val).required()
    }
  },
  data () {
    return {
      selectedIndex: -1,
      inputValue: '',
      selected: null,
      isComposing: false,
      isFetching: false,
      list: []
    }
  },
  computed: {
    ...mapGetters({
      isLoadingHotel: 'hotels/isLoadingHotel',
      hotel: 'hotels/hotel',
      isDesktop: 'isDesktop',
      selectedCurrency: 'user/selectedCurrency'
    }),
    isLoading: function () {
      return this.isComposing || this.isFetching
    },
    searchKeyword () {
      return this.$route.params?.keyword || this.$route.query.search
    }
  },
  methods: {
    ...mapActions({
      fetchAutoCompleteSearchCallback: 'search/fetchAutoCompleteSearchCallback',
      getItemByAutoCompleteId: 'search/getItemByAutoCompleteId',
      fetchHotelInventory: 'hotels/fetchHotelInventory',
      fetchHotelInventoryPrice: 'hotels/fetchHotelInventoryPrice'
    }),
    ...mapMutations({
      resetInventory: 'hotels/RESET_INVENTORY'
    }),
    closeAIbot () {
      this.showAIbot = false
    },
    goToMoreContent: function () {
      this.$refs.placeDropdown.blurHandler()
      if (this.inputValue) {
        const newQuery = {
          ...this.$route.query
        }
        delete newQuery.searchId
        delete newQuery.searchType
        this.$router.push({
          name: 'Collects',
          params: {
            keyword: this.inputValue
          },
          query: newQuery
        })
      } else {
        this.$router.push({
          name: 'HotelsList'
        })
      }
      if (!this.isDesktop) {
        this.$searchMobileModal.toggle(false)
      }
    },
    /** TODO: 確認 blurHandler 是否已棄用 */
    blurHandler: function ($event) {
      if ($event.relatedTarget) {
        this.$refs.placeDropdown.blurHandler()
      }
      if (this.searchKeyword) {
        this.selected = this.list.find(item => item.name === this.searchKeyword)
        console.debug('[Selected item update - search]: ', this.selected)
      }
      if (this.inputValue) {
        this.selected = this.list.find(item => item.name === this.inputValue)
        console.debug('[Selected item update - input value]: ', this.selected)
      }
    },
    focusHandler: function ($event) {
      if (this.isDesktop || this.forceDesktop) {
        this.$refs.placeDropdown.focusHandler()
      }
    },
    searchInputClick: function ($event) {
      if (this.$route.name === 'Home') {
        animateScrollTo(document.getElementById('search-place__input'), {
          offset: -20
        })
        window.dataLayer.push({
          event: 'index_searchbar_area'
        })
      } else {
        window.dataLayer.push({
          event: 'list_searchbar_area'
        })
      }
    },
    doValidate: function () {
      return this.$validate().then(success => {
        if (success) {
          console.debug('[Selected item validated]:', this.selected)
          return this.selected
        } else {
          if (!this.inputValue) {
            this.focusHandler()
            throw this.validation
          } else {
            return this.inputValue
          }
        }
      })
    },
    compositionHandler: function ($event) {
      if ($event.type === 'compositionstart') {
        console.debug('compositionstart')
        this.isComposing = true
        this.$refs.placeDropdown.focusHandler()
      }
      if ($event.type === 'compositionupdate') {
        // console.debug('compositionupdate')
      }
      if ($event.type === 'compositionend') {
        console.debug('compositionend')
        this.isComposing = false
      }
    },
    onArrowKeysPressed: function ($event) {
      if (this.isComposing) return false
      if (!this.$refs.placeDropdown.isOpen) {
        this.$refs.placeDropdown.focusHandler()
      }
      console.debug('onArrowKeysPressed', $event)
      switch ($event.code) {
        case 'Enter':
          if (this.selectedIndex > -1) {
            this.onResultCardClick(this.list[this.selectedIndex])
          }
          break
        case 'ArrowUp':
          if (this.selectedIndex > 0) {
            this.selectedIndex--
          } else if (this.selectedIndex === 0) {
            this.selectedIndex = 4
          }
          break
        case 'ArrowDown':
          if (this.selectedIndex < 4) {
            this.selectedIndex++
          } else if (this.selectedIndex === 4) {
            this.selectedIndex = 0
          }
          break
      }
    },
    onResultCardClick: function ($event) {
      console.debug('onResultCardClick', $event, $event.type)
      if (this.$route.name === 'Home') {
        window.dataLayer.push({
          event: 'index_searchbar_area_option'
        })
      } else {
        window.dataLayer.push({
          event: 'list_searchbar_area_option'
        })
      }

      if ($event.type === 'experience') {
        window.open(`https://www.owlting.com/experiences/products/${$event.externalId}`, '_blank')
      }
      // 確保點了一個同樣名字但id不一樣的，要讓first列表做變動
      const oldSelected = this.selected && JSON.parse(JSON.stringify(this.selected))
      const oldInputValue = this.inputValue && JSON.parse(JSON.stringify(this.inputValue))
      this.selected = $event
      this.inputValue = $event.name
      if (oldInputValue === $event.name && oldSelected?.id !== $event.id) {
        this.fetchData($event.name)
      }
      this.$refs.placeDropdown.blurHandler()
      this.$refs.placeInput.blur()
      if (this.$route.query?.searchId !== $event?.id && this.$route.query?.page) {
        this.$route.query.page = 1
      }
    },
    getInitialInputValue: async function ($route) {
      const route = $route || this.$route

      if (route.query.searchId) {
        await this.getItemByAutoCompleteId(route.query.searchId).then(res => {
          if (res) {
            this.selected = res
            console.debug('[Selected item update - get initial]: ', this.selected)
          }
        })
      }
      if (route.name === 'HotelDetail' && this.hotel?.hotelName) {
        this.inputValue = this.hotel.hotelName
      } else if (route.query?.search) {
        this.inputValue = route.query.search
      } else if (route.params?.keyword) {
        this.inputValue = route.params.keyword
      }
    },
    fetchData: function (val) {
      return this.fetchAutoCompleteSearchCallback({ query: val, ...this.inputValue && { first: this.selected?.id } }).then(res => {
        if (res) {
          if (val) {
            this.list = res.data
          } else {
            this.list = res.data[0].content
          }
          // if (this.$route.params?.hotelId) {
          //   this.selected = this.list.find(item => item.externalId === this.$route.params?.hotelId)
          // } else {
          if (!this.selected) {
            if (this.inputValue.length <= 50 && this.inputValue.length) {
              this.selected = this.list.find(item => item.name.toLowerCase() === this.inputValue.toLowerCase())
              if (!this.selected) {
                this.selected = this.list.find(item => item.type === 'county')
              }
            } else {
              this.selected = this.list.find(item => this.inputValue.indexOf(item.name) === 0)
            }
          } else {
            if (this.selected.name !== this.inputValue) { // 如果selected有預設值得時後
              console.debug('%c[Selected items and inputValue not Match!]', this.selected.name, this.inputValue)
              const duplicateOrNot = this.list.filter(item => item.name.toLowerCase() === this.inputValue.toLowerCase()) // like棉花糖民宿有大於一個的情況下
              if (duplicateOrNot.length > 1) { // 如果有好多的棉花糖，那就再多比較hotelId
                this.selected = this.list.find(item => (item.name.toLowerCase() === this.inputValue.toLowerCase() && item.externalId?.toLowerCase() === this.$route.params?.hotelId))
              } else {
                this.selected = this.list.find(item => item.name.toLowerCase() === this.inputValue.toLowerCase())
              }
            }
          }
          // }
          console.debug('[Selected item update - fetch]: ', this.selected, this.list, this.inputValue, val)
        }
        return val
      }).finally(() => {
        this.isFetching = false
      })
    },
    gaEvent () {
      window.dataLayer.push({
        event: 'index_searchbar_chatjuju'
      })
    }
  },
  created () {
    // if (this.$route.name === 'HotelDetail') {
    this.resetInventory()
    // }
    this.getInitialInputValue()
    this.fetchData(this.searchKeyword)
  },
  // mounted () {
  //   this.$nextTick(() => {
  //     console.log('search hero', document.getElementsByClassName('hero__search')[0].offsetWidth)
  //     document.getElementsByClassName('search-place__dropdown')[0].style.width = document.getElementsByClassName('hero__search')[0].offsetWidth - 32 + 'px'
  //   })
  // },
  watch: {
    inputValue: {
      handler: _.debounce(async function (val) {
        console.debug('[watch] inputValue', val)
        this.isFetching = true
        this.fetchData(val)
      }, 1000)
      // handler: async function (val) {
      //   console.debug('[watch] inputValue', val)
      //   this.isFetching = true
      //   this.fetchData(val)
      // }
    },
    $route: {
      handler: function ($route) {
        // 預設頁不是獨立的頁面，而是渲染在hotelsList頁裡，所以用 route.name 加上無 route.query 判斷
        const isDefaultRecommendPage = this.$route.name === 'HotelsList' && _.isEmpty(this.$route.query)
        this.getInitialInputValue($route)
        if (isDefaultRecommendPage) {
          this.inputValue = ''
        }
      }
    },
    isLoadingHotel: function (val, oldVal) {
      if (this.$route.name === 'HotelDetail') {
        if (!!oldVal && !val) {
          this.getInitialInputValue()
        }
      }
    },
    selected: function (val, oldVal) {
      if (this.$route.name === 'HotelDetail') {
        if (val?.externalId !== oldVal?.externalId && val?.externalId === this.$route.params?.hotelId && val?.source === 'owljourney') {
          this.fetchHotelInventory({
            startDate: this.$dayjs().format('YYYY-MM'),
            endDate: this.$dayjs().add(1, 'year').format('YYYY-MM'),
            hotelUUID: val?.externalId,
            source: val?.source
          })
          this.fetchHotelInventoryPrice({
            hotelUUID: val?.externalId,
            source: val?.source,
            currency: this.selectedCurrency,
            adult: this.$route.query.adult || 2
          })
        }
      }
      if (!val?.externalId || val?.externalId !== this.$route.params?.hotelId) {
        this.resetInventory()
      }
    },
    selectedCurrency: function (val) {
      if (this.$route.name === 'HotelDetail') {
        if (this.selected?.externalId === this.$route.params?.hotelId && this.selected?.source === 'owljourney') {
          this.fetchHotelInventoryPrice({
            hotelUUID: this.selected?.externalId,
            source: this.selected?.source,
            currency: this.selectedCurrency,
            adult: this.$route.query.adult || 2
          })
        }
      }
    },
    '$route.query.adult': {
      handler: function (val) {
        if (this.$route.name === 'HotelDetail' && this.selected?.externalId) {
          this.fetchHotelInventoryPrice({
            hotelUUID: this.selected?.externalId,
            source: this.selected?.source,
            currency: this.selectedCurrency,
            adult: val
          })
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="sass" scoped>
.search-place
  @apply relative
  &__input
    @apply relative
    @apply flex items-center
    @apply bg-grey-lightest
    @apply rounded-full
    // border-radius: 0.375rem
    .icon
      @apply absolute
      @apply text-xl text-grey-darker block
      @apply pointer-events-none select-none
      top: 0
      left: 0
      @apply my-8 ml-12
    input
      @apply py-8 pl-48 pr-12 flex-auto
      line-height: 1 // IME 輸入時顯示底線
      max-width: 100%
  &__mobile-input
    overflow: hidden
    text-overflow: ellipsis
    display: -webkit-box
    -webkit-box-orient: vertical
    -webkit-line-clamp: 2
    line-height: 1.5em
    max-height: 3em
  &__dropdown
    @apply hidden absolute w-full rounded-lg overflow-hidden
    top: 0
    z-index: -1
    &.is-open
      @apply block
      box-shadow: 0 0 2px 2px rgba(0, 0, 0, .03)
      .chatbot-block
        @apply bg-white rounded-t-sm px-16 pt-8
</style>
